<template>
  <div class="profile-screen">
    <div class="event-wrap" v-if="$route.name==='eventEdit' || $route.name==='eventsStep'">
      <ThemedTitle :font="current_style.font">Событие</ThemedTitle>
      <ThemedEventInfo :font="current_style.font" :borderRadius="current_style.borderRadius">
        <ThemedLine :fontSize15="current_style.fontSize15">
          <div class="icon">
            <SvgIcon name="cal" width="17px" height="17px" :color="current_style.primary"></SvgIcon>
          </div>
          <ThemedDatePlaceText :font="current_style.font">{{date_convert(event.date_at)}}</ThemedDatePlaceText>
        </ThemedLine>
        <ThemedLine :fontSize15="current_style.fontSize15">
          <div class="icon">
            <SvgIcon name="map" width="17px" height="17px" :color="current_style.primary"></SvgIcon>
          </div>
          <ThemedDatePlaceText :font="current_style.font">{{typo(event.place||'Место проведения')}}
          </ThemedDatePlaceText>
        </ThemedLine>
        <ThemedTitleLine ref="eventTitle" :font="current_style.font">
          {{typo(event.title||'Название события')}}
        </ThemedTitleLine>
      </ThemedEventInfo>
    </div>
    <div class="pic-wrap">
      <div class="avatar" :class="{avatarDefault:!profile.avatar}" :style="bg(profile.avatar)"></div>
      <div class="layout" :class="{layDefault:!profile.layout}" :style="bg(profile.layout)"></div>
    </div>
    <div class="form-wrap">
      <ThemedUserName :font="current_style.font" ref="profilename">{{name}}</ThemedUserName>
      <ThemedDateSince :font="current_style.font" :textGray="current_style.textGray">на fotty с {{dateConvert}}
      </ThemedDateSince>
      <div class="btn-wrap">
        <ThemedButton :font="current_style.font" :primary="current_style.primary"
                      :borderRadius="current_style.borderRadius" :class="{active : profile.phone}">Позвонить
        </ThemedButton>
        <ThemedButton :font="current_style.font" :primary="current_style.primary"
                      :borderRadius="current_style.borderRadius" :class="{active : profile.email}">Написать
        </ThemedButton>
      </div>
      <div class="contact-wrap">
        <article v-for="(item, key) in profile.socials" :key="key">
          <ThemedContactRow
            :font="current_style.font"
            :primary="current_style.primary"
            :borderRadius="current_style.borderRadius"
            :shadowOffsetX="current_style.shadowOffsetX"
            :shadowOffsetY="current_style.shadowOffsetY"
            :shadowRadius="current_style.shadowRadius"
            :shadowOpacity="current_style.shadowOpacity"
            :shadow="current_style.shadow"
            :class="{active:item.link}"
          >
            <div class="ico-wrap">
              <div class="icon">
                <SvgIcon
                  href="'/'+item.icon"
                  :name="item.icon"
                  :width="item.size[0]+'px'"
                  :height="item.size[1]+'px'"
                ></SvgIcon>
              </div>
            </div>
            <div class="link" v-if="!item.link">
              {{item.title}}
              <SvgIcon name="forward" class="forward-icon" width="10px" height="10px"></SvgIcon>
            </div>
            <div class="link" v-else>
              {{item.view}}
              <SvgIcon name="forward" class="forward-icon" width="10px" height="10px"></SvgIcon>
            </div>
          </ThemedContactRow>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import Typograf from 'typograf'
  import ThemedTitle from '../styled-components/ThemedTitle'
  import ThemedEventInfo from '../styled-components/ThemedEventInfo'
  import ThemedLine from '../styled-components/ThemedLine'
  import ThemedTitleLine from '../styled-components/ThemedTitleLine'
  import ThemedDatePlaceText from '../styled-components/ThemedDatePlaceText'
  import ThemedUserName from '../styled-components/ThemedUserName'
  import ThemedDateSince from '../styled-components/ThemedDateSince'
  import ThemedButton from '../styled-components/ThemedButton'
  import ThemedContactRow from '../styled-components/ThemedContactRow'
  import { Default_style } from '../../../library/lib'

  let tp = new Typograf({locale: ['ru', 'en-US']})
  import { createNamespacedHelpers } from 'vuex'

  const {mapState} = createNamespacedHelpers('design')

  export default {
    name: 'Profile',
    props: ['profile', 'event'],
    components: {
      ThemedTitle,
      ThemedEventInfo,
      ThemedLine,
      ThemedTitleLine,
      ThemedDatePlaceText,
      ThemedUserName,
      ThemedDateSince,
      ThemedButton,
      ThemedContactRow
    },
    methods: {
      bg: function (link = '') {
        if (!link) return ''
        return `background-image:url(${link})`
      },
      typo: function (text) {
        return tp.execute(text)
      },
      date_convert: function (date) {
        return moment(date).format('DD MMMM YYYY')
      }
    },
    computed: {
      ...mapState(['styles']),
      current_style() {
        if ((this.event === undefined) || (this.event.style_id === undefined) || (this.event.style_id === ''))
          return Default_style()
        else {
          return this.styles.find(style => style.id === this.event.style_id).style_json
        }
      },
      name() {
        return this.profile.name.value || this.profile.name.default
      },
      dateConvert() {
        let _date = this.profile.regdate || moment()
        return moment(_date).format('DD MMMM YYYY')
      },
    },
    watch: {
      'profile.name.value': function () {
        setTimeout(() => {
          if (this.$refs.profilename.offsetHeight > 60)
            this.$refs.profilename.classList.add('overflowed')
          else this.$refs.profilename.classList.remove('overflowed')
        }, 100)
      }
    },
    mounted() {
      this.$parent.mActive = 'profile'
    },
  }
</script>

<style lang="scss" scope>
  .icon {
    margin-right: 10px;
    min-width: 14px;
  }
</style>
